/**
 * @name Pagination
 * @description Control del paginado del datagrid
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Material-UI
import { Pagination as PaginationLab } from '@material-ui/lab';

const Pagination = (props) => {
  const {
    rowsLength,
    pageSize,
    currentPage,
    onChangePage
  } = props;

  return (
    <Styled.FlexPagination>
      <Styled.Pagination
        shape="rounded"
        page={currentPage + 1}
        count={Math.ceil(rowsLength / pageSize)}
        siblingCount={1}
        boundaryCount={2}
        onChange={(event, page) => onChangePage(event, page)}
      />
    </Styled.FlexPagination>
  );
};

Pagination.propTypes = {
  // Longitud de registros.
  rowsLength: PropTypes.number,
  // Número de registros por página. 
  pageSize: PropTypes.number,
  // Número de página actual.
  currentPage: PropTypes.number,
  // Función a ejecutar cuando se cambie el número de página.
  onChangePage: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FlexPagination = styled.div`
  display: flex;
  flex-basis: 200px;
  flex-grow: 3;
  align-items: center;
  justify-content: center;
`;

// Pagination LAB
Styled.Pagination = styled(PaginationLab)`
  .MuiPaginationItem-root {
    /* font-family: 'Bryant Pro Medium'; */
    font-variant: tabular-nums;
    font-size: ${(props) => props.theme.typography.smallText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.0175em;
    color: ${(props) => props.theme.colors.greyDark};
  }

  .MuiPaginationItem-page.Mui-selected {
    background-color: ${(props) => props.theme.colors.greyLight}
  }

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

export default Pagination;
